export default {"src":"/_next/static/media/golf.88059e02.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};